import parse from 'html-react-parser';
import { memo, Fragment } from 'react';
import { Row } from 'react-bootstrap';

const PrescriptionFooter = ({ footerInfo, prescriptionSetting }) => {
  let footerData = footerInfo?.contents?.map((data, index) => {
    return (
      <div style={{ width: data.width + '%' }} key={index}>
        {parse(data.content.replace(/<p>&nbsp;<\/p>/gi, ''))}
      </div>
    );
  });

  const footerStyle = {
    height:
      prescriptionSetting?.footer?.height?.quantity +
      prescriptionSetting?.footer?.height?.unit,
  };

  return (
    <Fragment>
      <div className="show-in-print">
        {prescriptionSetting?.isPadPrescription ? (
          <Row className="d-flex" style={footerStyle}></Row>
        ) : (
          <Row className="blank-footer-print d-flex">{footerData}</Row>
        )}
      </div>
      <Row className="footer hide-in-print">{footerData}</Row>
    </Fragment>
  );
};

export default memo(PrescriptionFooter);
